/**
 * Bookmaker color palette for distinguishing lines in charts
 * Sharp books use purple/violet tones
 * Square books use warm colors (orange, red, yellow, green, etc.)
 */
export const BOOKMAKER_COLORS: Record<string, { home: string; away: string }> = {
  pinnacle: { home: '#a855f7', away: '#c084fc' },      // Purple (sharp)
  betfair: { home: '#8b5cf6', away: '#a78bfa' },       // Violet (sharp)
  circa: { home: '#7c3aed', away: '#a78bfa' },         // Violet dark (sharp)
  westgate: { home: '#6366f1', away: '#818cf8' },      // Indigo (sharp)
  bookmaker: { home: '#4f46e5', away: '#6366f1' },     // Indigo dark (sharp)
  draftkings: { home: '#f97316', away: '#fb923c' },    // Orange (square)
  fanduel: { home: '#ef4444', away: '#f87171' },       // Red (square)
  betmgm: { home: '#eab308', away: '#facc15' },        // Yellow (square)
  caesars: { home: '#22c55e', away: '#4ade80' },       // Green (square)
  pointsbet: { home: '#06b6d4', away: '#22d3ee' },     // Cyan (square)
  betrivers: { home: '#ec4899', away: '#f472b6' },     // Pink (square)
  unibet: { home: '#14b8a6', away: '#2dd4bf' },        // Teal (square)
  default: { home: '#6b7280', away: '#9ca3af' },       // Gray fallback
};

/**
 * List of sharp bookmaker names for detection
 */
export const SHARP_BOOK_NAMES = ['pinnacle', 'betfair', 'circa', 'westgate', 'bookmaker'];

/**
 * List of square bookmaker names for detection
 */
export const SQUARE_BOOK_NAMES = ['draftkings', 'fanduel', 'betmgm', 'caesars', 'pointsbet'];
